 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"collections":"collections","settings":"settings"}[chunkId]||chunkId) + "." + {"chunk-1f67f8a7":"77db5a59","chunk-2d0de67b":"16cc22a5","chunk-2d0e19c1":"77096fe0","chunk-2d2183ef":"24c0f909","chunk-3c7f0438":"bc61e8d6","chunk-58ad2634":"f0834f22","chunk-6511009b":"b29282b8","chunk-6956e363":"442e36b3","chunk-7241aa61":"f3fdaa48","chunk-8021bb3a":"df8d7968","chunk-7ca4bade":"44446217","chunk-146a1a26":"df4163ee","chunk-ae3868b2":"2ba4c7c0","collections":"a303d508","chunk-9d4ee130":"4b1f8419","chunk-fe87507e":"501230f0","settings":"89413439","chunk-138c0c34":"54411083","chunk-166b5fa6":"4eaa5d0b","chunk-2d0e8853":"11209152","chunk-2d0e905a":"b1acb2f2","chunk-5114e84c":"e1303d21","chunk-55ebb8ff":"39cfaf17","chunk-5ba885c6":"9f7fae49","chunk-c48613d2":"ffb1e676","chunk-0b6b4a80":"033fe33d","chunk-2d0c932b":"a8d32369","chunk-2d0f1566":"3ae8dbfd","chunk-8ee855e2":"1faf2a8c","chunk-baf4bb92":"cc7db590","chunk-ed02ca82":"09d546f9","chunk-2c01ff8a":"953e03f4","chunk-2d0dd07f":"df926264","chunk-2d21b0ce":"85ff51b0","chunk-41a49998":"32bdb015","chunk-64c3c8aa":"9618a036","chunk-b7357a60":"f90976bc","chunk-b736eea0":"c8f8d607","chunk-eb93e7d4":"9a14c8a9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1f67f8a7":1,"chunk-3c7f0438":1,"chunk-58ad2634":1,"chunk-6511009b":1,"chunk-6956e363":1,"chunk-7241aa61":1,"chunk-8021bb3a":1,"chunk-7ca4bade":1,"chunk-146a1a26":1,"chunk-ae3868b2":1,"collections":1,"chunk-9d4ee130":1,"chunk-fe87507e":1,"settings":1,"chunk-138c0c34":1,"chunk-5114e84c":1,"chunk-55ebb8ff":1,"chunk-5ba885c6":1,"chunk-c48613d2":1,"chunk-8ee855e2":1,"chunk-baf4bb92":1,"chunk-ed02ca82":1,"chunk-2c01ff8a":1,"chunk-41a49998":1,"chunk-64c3c8aa":1,"chunk-eb93e7d4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"collections":"collections","settings":"settings"}[chunkId]||chunkId) + "." + {"chunk-1f67f8a7":"537dd52b","chunk-2d0de67b":"31d6cfe0","chunk-2d0e19c1":"31d6cfe0","chunk-2d2183ef":"31d6cfe0","chunk-3c7f0438":"ae465536","chunk-58ad2634":"60b7a7e7","chunk-6511009b":"aea2343c","chunk-6956e363":"3adb1afb","chunk-7241aa61":"676de675","chunk-8021bb3a":"2c9d8920","chunk-7ca4bade":"b0cf7376","chunk-146a1a26":"23844ef9","chunk-ae3868b2":"e3bc7752","collections":"ba863294","chunk-9d4ee130":"9aed2940","chunk-fe87507e":"854326f1","settings":"2447ba4b","chunk-138c0c34":"2101d3ff","chunk-166b5fa6":"31d6cfe0","chunk-2d0e8853":"31d6cfe0","chunk-2d0e905a":"31d6cfe0","chunk-5114e84c":"1f3e9e8b","chunk-55ebb8ff":"66125037","chunk-5ba885c6":"4a80608c","chunk-c48613d2":"5ab99efd","chunk-0b6b4a80":"31d6cfe0","chunk-2d0c932b":"31d6cfe0","chunk-2d0f1566":"31d6cfe0","chunk-8ee855e2":"5cb2956e","chunk-baf4bb92":"ac0af368","chunk-ed02ca82":"fa9c3732","chunk-2c01ff8a":"fa9c3732","chunk-2d0dd07f":"31d6cfe0","chunk-2d21b0ce":"31d6cfe0","chunk-41a49998":"5cb2956e","chunk-64c3c8aa":"ac0af368","chunk-b7357a60":"31d6cfe0","chunk-b736eea0":"31d6cfe0","chunk-eb93e7d4":"167c0c4c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([4,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
